import theme from './theme.yaml'

export default {
  theme,
}
